import submersibleproduct1 from "../../../images/productsImages/submersibleImages/products/Industrial/AguasNegras/OS.jpg";
import submersibleproduct2 from "../../../images/productsImages/submersibleImages/products/Industrial/AguasNegras/OSC.jpg";
import submersibleproduct3 from "../../../images/productsImages/submersibleImages/products/Industrial/AguasNegras/OSG.jpg";
import submersibleproduct4 from "../../../images/productsImages/submersibleImages/products/Industrial/AguasNegras/SerieFWS.png";
import submersibleproduct5 from "../../../images/productsImages/submersibleImages/products/Industrial/AguasNegras/20E.jpg";
import submersibleproduct6 from "../../../images/productsImages/submersibleImages/products/Industrial/AguasNegras/20S.jpg";
import submersibleproduct7 from "../../../images/productsImages/submersibleImages/products/Industrial/AguasNegras/WSEFFLUENT.jpg";
import submersibleproduct8 from "../../../images/productsImages/submersibleImages/products/Industrial/AltaEficiencia/AltaEficiencia.png";
import submersibleproduct9 from "../../../images/productsImages/submersibleImages/products/Industrial/BombasSumergibles/FE/SSI.jpg";
import submersibleproduct10 from "../../../images/productsImages/submersibleImages/products/Industrial/BombasSumergibles/FE/STS.jpg";
import submersibleproduct12 from "../../../images/productsImages/submersibleImages/products/Industrial/BombasSumergibles/SPERONI/SPINOX.jpg";
import submersibleproduct13 from "../../../images/productsImages/submersibleImages/products/Industrial/MotoresSumergibles/NEMA6FOTO.jpg";
import submersibleproduct14 from "../../../images/productsImages/submersibleImages/products/Industrial/MotoresSumergibles/Nema8.jpg";
import submersibleproduct15 from "../../../images/productsImages/submersibleImages/products/Industrial/MotoresSumergibles/Brochure-Motores-Rebobinables-01.png";
import submersibleproduct19 from "../../../images/productsImages/submersibleImages/products/Industrial/MotoresSumergibles/motorencapsulado6.jpg";
import submersibleproduct20 from "../../../images/productsImages/submersibleImages/products/Industrial/AguasNegras/OE.jpg";
import submersibleproduct21 from "../../../images/productsImages/submersibleImages/products/Industrial/AguasNegras/GD.jpg";
import submersibleproduct22 from "../../../images/productsImages/submersibleImages/products/Industrial/AguasNegras/XV.jpg";
import submersibleproduct23 from "../../../images/productsImages/submersibleImages/products/Industrial/AguasNegras/SVN.jpg";
import submersibleproduct24 from "../../../images/productsImages/submersibleImages/products/Industrial/AguasNegras/SV.jpg";
import pdf1 from "../../../pdf/submersible/industrial/OS.pdf";
import pdf2 from "../../../pdf/submersible/industrial/OSC.pdf";
import pdf3 from "../../../pdf/submersible/industrial/OSG.pdf";
import pdf4 from "../../../pdf/submersible/industrial/FWS.pdf";
import pdf5 from "../../../pdf/submersible/industrial/20e.pdf";
import pdf6 from "../../../pdf/submersible/industrial/20s.pdf";
import pdf7 from "../../../pdf/submersible/industrial/ws.pdf";
import pdf8 from "../../../pdf/submersible/industrial/AltaEficiencia.pdf";
import pdf9 from "../../../pdf/submersible/industrial/SSI.pdf";
import pdf10 from "../../../pdf/submersible/industrial/STS.pdf";
import pdf12 from "../../../pdf/submersible/industrial/SerieSP.pdf";
import pdf13 from "../../../pdf/submersible/industrial/NEMA6.pdf";
import pdf14 from "../../../pdf/submersible/industrial/NEMA8.pdf";
import pdf15 from "../../../pdf/submersible/industrial/Rebobinables.pdf";
import pdf19 from "../../../pdf/submersible/industrial/motorencapsulado6.pdf";
import pdf20 from "../../../pdf/submersible/industrial/OE.pdf";
import pdf21 from "../../../pdf/submersible/industrial/serieGD.pdf";
import pdf22 from "../../../pdf/submersible/industrial/serieXV.pdf";
import pdf23 from "../../../pdf/submersible/industrial/Seriesvn.pdf";
import pdf24 from "../../../pdf/submersible/industrial/SerieSV.pdf";

const fe = "Franklin Electric";
const submersibleIndustrialProductList = [
  {
    _id: "subcatindagubgp001a",
    image: submersibleproduct1,
    title: "Bomba sumergible aguas negras OS",
    code: "BGP-OS",
    category: "Aguas Negras",
    brand: "BGP",
    subcategory: "BGP",
    downLoad: pdf1,
  },
  {
    _id: "subcatindagubgp001b",
    image: submersibleproduct2,
    title: "Bomba sumergible aguas negras OSC",
    code: "BGP-OSC",
    category: "Aguas Negras",
    brand: "BGP",
    subcategory: "BGP",
    downLoad: pdf2,
  },
  {
    _id: "subcatindagubgp001d",
    image: submersibleproduct20,
    title: "Bomba sumergible aguas negras OE",
    code: "BGP-OE",
    category: "Aguas Negras",
    brand: "BGP",
    subcategory: "BGP",
    downLoad: pdf20,
  },
  {
    _id: "subcatindagufe001a",
    image: submersibleproduct4,
    title: "Bombas sumergibles aguas negras serie FWS",
    code: "FPS",
    category: "Aguas Negras",
    brand: fe,
    subcategory: fe,
    downLoad: pdf4,
  },
  {
    _id: "subcatindaguLG001a",
    image: submersibleproduct5,
    title: "Bombas sumergibles aguas negras serie 20E",
    code: "20E",
    category: "Aguas Negras",
    brand: "Little Giant",
    subcategory: "Little Giant",
    downLoad: pdf5,
  },
  {
    _id: "subcatindaguLG001b",
    image: submersibleproduct6,
    title: "Bombas sumergibles aguas negras serie 20S",
    code: "20S",
    category: "Aguas Negras",
    brand: "Little Giant",
    subcategory: "Little Giant",
    downLoad: pdf6,
  },
  {
    _id: "subcatindaguLG001c",
    image: submersibleproduct7,
    title: "Bombas sumergibles aguas negras serie WS",
    code: "WS",
    category: "Aguas Negras",
    brand: "Little Giant",
    subcategory: "Little Giant",
    downLoad: pdf7,
  },
  {
    _id: "subcatindagusperoni001b",
    image: submersibleproduct22,
    title: "Bombas sumergibles aguas negras serie XV",
    code: "Speroni-XV",
    category: "Aguas Negras",
    brand: "Speroni",
    subcategory: "Speroni",
    downLoad: pdf22,
  },
  {
    _id: "subcatindagusperoni001c",
    image: submersibleproduct23,
    title: "Bombas sumergibles aguas negras serie SVN",
    code: "Speroni-SVN",
    category: "Aguas Negras",
    brand: "Speroni",
    subcategory: "Speroni",
    downLoad: pdf23,
  },
  {
    _id: "subcatindagusperoni001d",
    image: submersibleproduct24,
    title: "Bombas sumergibles aguas negras serie SV",
    code: "Speroni-SV",
    category: "Aguas Negras",
    brand: "Speroni",
    subcategory: "Speroni",
    downLoad: pdf24,
  },
  {
    _id: "subcatindagubgp001c",
    image: submersibleproduct3,
    title: "Bomba sumergible aguas negras OSG",
    code: "BGP-OSG",
    category: "Trituradora",
    brand: "BGP",
    subcategory: "BGP",
    downLoad: pdf3,
  },
  {
    _id: "subcatindagusperoni001a",
    image: submersibleproduct21,
    title: "Bombas sumergibles trituradora serie GD",
    code: "Speroni-GD",
    category: "Trituradora",
    brand: "Speroni",
    subcategory: "Speroni",
    downLoad: pdf21,
  },
  {
    _id: "subcatindalt001a",
    image: submersibleproduct8,
    title: "Sistema de bombeo de alta eficiencia",
    code: "",
    category: "Alta Eficiencia",
    brand: fe,
    subcategory: fe,
    downLoad: pdf8,
  },
  {
    _id: "subcatindbomFE001a",
    image: submersibleproduct9,
    title: "Bomba de acero inoxidable serie SSI",
    code: "FE-SSI",
    category: "Bombas Sumergibles",
    brand: fe,
    subcategory: fe,
    downLoad: pdf9,
  },
  {
    _id: "subcatindbomFE001b",
    image: submersibleproduct10,
    title: "Bombas sumergibles turbina serie STS",
    code: "FE-STS",
    category: "Bombas Sumergibles",
    brand: fe,
    subcategory: fe,
    downLoad: pdf10,
  },
  {
    _id: "subcatindbomsperoni001a",
    image: submersibleproduct12,
    title: "Bombas sumergibles de acero inoxidable SP",
    code: "",
    category: "Bombas Sumergibles",
    brand: "Speroni",
    subcategory: "Speroni",
    downLoad: pdf12,
  },
  {
    _id: "subcatindmotFEl001a",
    image: submersibleproduct13,
    title: `Motor Sand Fighter de 6"`,
    code: "",
    category: "Motores Sumergibles",
    brand: fe,
    subcategory: fe,
    downLoad: pdf13,
  },
  {
    _id: "subcatindmotFEl001b",
    image: submersibleproduct14,
    title: `Motores sumergibles encapsulados de 8"`,
    code: "",
    category: "Motores Sumergibles",
    brand: fe,
    subcategory: fe,
    downLoad: pdf14,
  },
  {
    _id: "subcatindmotFEl001c",
    image: submersibleproduct15,
    title: `Motores sumergibles rebobinables de 8", 10" y 12"`,
    code: "",
    category: "Motores Sumergibles",
    brand: fe,
    subcategory: fe,
    downLoad: pdf15,
  },
  {
    _id: "subcatindmotSperoni001a",
    image: submersibleproduct19,
    title: `Motor encapsulado en resina 6"`,
    code: "MOP",
    category: "Motores Sumergibles",
    brand: "Speroni",
    subcategory: "Speroni",
    downLoad: pdf19,
  },
];
export default submersibleIndustrialProductList;
